// extracted by mini-css-extract-plugin
export default {"h2":"Queue_h2__IwvKE","queue":"Queue_queue__WmDEa","item":"Queue_item__zK+WV"};